export function renderIcon(name: string) {
    switch (name) {
        case 'header-menu':
        case 'header-home':
        case 'header-user':
        case 'menu-address':
        case 'menu-invoices':
        case 'menu-loyalty':
        case 'menu-orders':
        case 'menu-preferences':
        case 'menu-calendar':
        case 'icon-loyalty':
        case 'icon-loyalty-gold':
        case 'menu-invite-friend':
        case 'navigation-home':
        case 'navigation-user':
        case 'navigation-options':
        case 'navigation-cart':
        case 'navigation-calendar':
        case 'navigation-locations':
        case 'navigation-delivery':
        case 'brew-coffee-beans':
        case 'brew-cup':
        case 'brew-temperature':
        case 'brew-water':
        case 'menu-recipes':
            return <img className="icon" src={"/svg/" + name + ".svg"} alt="" />
    }
    switch (name) {
        case 'header-menu':
            return <i className="fa fa-bars" />
        case 'header-home':
            return <i className="fa fa-home" />
        case 'header-user':
            return <i className="fa fa-user" />
    }
}